import { render, staticRenderFns } from "./ViewLeadSampleOrdersPopUp .vue?vue&type=template&id=5c3f68b2&scoped=true&"
import script from "./ViewLeadSampleOrdersPopUp .vue?vue&type=script&lang=js&"
export * from "./ViewLeadSampleOrdersPopUp .vue?vue&type=script&lang=js&"
import style0 from "./ViewLeadSampleOrdersPopUp .vue?vue&type=style&index=0&id=5c3f68b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f68b2",
  null
  
)

export default component.exports